<form clrForm
      [formGroup]="editConditionForm">

  <ng-container *ngIf="conditions.length > 0">
    <input type="hidden" formControlName="type" placeholder="{{ conditions[0].cond_type }}" value="{{ conditions[0].cond_type }} ">

    <table class="table" id="conditionsTable">
      <thead>
      <tr>
        <th class="left">Bezeichnung</th>
        <th class="left">Beschreibung</th>
        <th class="left" *ngIf="conditions[0].cond_type == 1">Abweichende Lieferadresse</th>
        <th class="left" *ngIf="conditions[0].cond_type == 2">Zahlungsziel</th>
        <th class="left" *ngIf="conditions[0].cond_type == 2">Skonto (%)</th>
        <th>Aktion</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td class="left"><input type="text" formControlName="name" placeholder="{{ conditions[0].name }}" class="clr-input" value="{{ conditions[0].name }} "></td>
        <td class="left"><input type="text" formControlName="text" placeholder="{{ conditions[0].text }}" class="clr-input" value="{{ conditions[0].text }}"></td>
        <td class="left" *ngIf="conditions[0].cond_type == 1"><input type="checkbox" formControlName="option" class="clr-checkbox"></td>
        <td class="left" *ngIf="conditions[0].cond_type == 2"><clr-number-input-container><input clrNumberInput type="number" formControlName="payment_term" placeholder="{{ conditions[0].payment_term }}" value="{{ conditions[0].payment_term }}"></clr-number-input-container></td>
        <td class="left" *ngIf="conditions[0].cond_type == 2"><clr-number-input-container><input clrNumberInput type="number" formControlName="discount" placeholder="{{ conditions[0].discount }}" class="clr-number-input" value="{{ conditions[0].discount }}"></clr-number-input-container></td>
        <td class="btn-group btn-primary btn-icon center">
          <button class="btn btn-sm" (click)="updateCondition()" [disabled]="editConditionForm.invalid">
            <cds-icon shape="floppy"></cds-icon>
            <span class="clr-icon-title">Speichern</span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </ng-container>
</form>

<br /><a class="btn btn-warning-outline btn-sm" (click)="cancelEdit()">Abbrechen {{ conditions[0]?.name }}</a>


<pre>{{ editConditionForm.value | json }}</pre>
